import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import infoList from "@/mixins/infoList";
import userBanned from "./userBanned.vue";
import accountBanned from "./accountBanned.vue";
import ipBanned from "./ipBanned.vue";
import ipCount from "./ipCount.vue";
import timeDateOptions from "../../components/timeList/timeDateOptions.vue";
import exportCsv from "@/mixins/exportCsv";
export default {
  components: {
    userBanned: userBanned,
    accountBanned: accountBanned,
    ipBanned: ipBanned,
    timeDateOptions: timeDateOptions,
    ipCount: ipCount
  },
  name: "banned",
  mixins: [infoList, exportCsv],
  data: function data() {
    return {
      activeName: "first",
      exportBanDialog: false,
      timedata: [this.$moment().subtract(1, "days").format("YYYY-MM-DD 00:00:00"), this.$moment().format("YYYY-MM-DD 23:59:59")],
      exportType: 1,
      options: [{
        label: "角色封禁记录",
        value: 1
      }, {
        label: "账号封禁记录",
        value: 2
      }, {
        label: "IP封禁记录",
        value: 3
      }, {
        label: "聊天封禁记录",
        value: 4
      }]
    };
  },
  mounted: function mounted() {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    exportLog: function exportLog(m) {
      this.exportBanDialog = true;
      // const url = "/api/xcpOpsManager/role/exportBanLog?";
      // this.exportCsv(url,m)
    },
    exportClick: function exportClick() {
      var url = "/api/xcpOpsManager/role/exportBanLog?";
      this.exportCsv(url, {
        type: this.exportType,
        sdate: this.timedata[0],
        edate: this.timedata[1]
      });
    },
    handleClick: function handleClick(e) {
      console.log(e);
    }
  }
};